import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';

import store from '../../store';
import {setMedia, setSection} from '../../slices/statusSlice';
import {finalizeConfiguration, updatePersonalisation} from '../../slices/configurationSlice';

import loading from '../../../icons/loading';
import personalisation from '../../../icons/personalisation';
import next from '../../../icons/next';

import {
	selectSpcIsSatisfied, selectFamily, selectShowPersonalisation
} from '../../selectors';

@customElement('finalize-cta')
export class FinalizeCTA extends connect(store)(navigator(LitElement)) {

	static styles = css`
		:host {
			padding: var(--padding);
			display: flex;
			justify-content: center;
			position: fixed;
			width: 100%;
			bottom: 0;
			left: 0;
			z-index: 1000;
			background-color: var(--color-black);
			border-top: 1px solid var(--color-grey5);
		}

		.ctaButtons {
			display: flex;
			flex-direction: row;

			padding-bottom: var(--padding);
			gap: var(--very-small-padding);
		}
		.ctaButton {
			display: flex;
			flex-direction: column;
			gap: var(--very-small-padding);
		}
		.ctaInfo {
			font: var(--font-widget-label);
			color: var(--color-grey4);
		}

		button {
			text-align: left;
			font: var(--font-widget-label);
			color: var(--color-black);
			display: block;
			flex-direction: column;
			justify-content: space-between;
			gap: var(--padding);
			background-color: transparent;
			border: none;
			cursor: pointer;
		}

		.downloadButton {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-small-title);
			padding: var(--very-small-padding) var(--padding);
			color: var(--color-black);
			background-color: var(--color-white);
		}

		.personaliseButton {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-small-title);
			padding: var(--very-small-padding) var(--padding);
			color: var(--color-white);
			background-color: var(--color-grey6);
		}

		.finalizeButton {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-small-title);
			padding: var(--very-small-padding) var(--padding);
			color: var(--color-black);
			background-color: var(--color-cta-button);
		}
		.finalizeButton.loading {
			pointer-events: none;
			background-color: var(--color-grey5);
			color: var(--color-white);
		}
		.icon {
			display: inline-block;
			height: 16px;
			width: 16px;
			color: var(--color-widget-text);
		}

		.downloadButton .icon {
			color: var(--color-black);
		}

		.personaliseButton .icon {
			color: var(--color-widget-text);
		}

		.finalizeButton .icon {
			color: var(--color-black);
		}

		.icon.state {
			color: var(--color-warn);
		}

		.icon.state.satisfied {
			color: var(--color-ok);
		}

		.icon svg {
			width: 100%;
			height: auto;
		}

	`;


	@property({type: Boolean})
	tenderTextCopied = false;

	constructor() {
		super();
		this.closeTimout = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;

		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		this.showPersonalisation = selectShowPersonalisation(state);

		this.finalized = state.configuration.data.finalized;
		this.loading = state.configuration.status === 'loading';
	}

	connectedCallback() {
		super.connectedCallback();
	}
	togglePersonalise() {
		store.dispatch(updatePersonalisation({name: 'active', value: !this.showPersonalisation}));
	}

	toFinalize() {
		store.dispatch(setSection({currentSection: 'finalize'}));
		store.dispatch(setMedia({media: 'sections'}));
	}

	onFinalizeConfiguration(e) {
		// capture images
		if (selectFamily(this.state) === 'Olivio' || selectFamily(this.state) === 'LightProfile') {
			const event = new CustomEvent('captureImages', {bubbles: true, composed: true});
			this.dispatchEvent(event);
		}
		//console.log('finalizeConfiguration');
		store.dispatch(finalizeConfiguration()); // generate
	}


	render() {
		return html`
			<div class="ctaButtons">
				<div class="ctaButton">
					<button class="personaliseButton" @click="${() => this.togglePersonalise()}">
						<span>${this.showPersonalisation ? msg('Hide Personalisation') : msg('Personalise Specsheet')}</span>
						<span class="icon">${personalisation}</span>
					</button>
				</div>
				<div class="ctaButton">
					<button class="finalizeButton ${classMap({loading: this.loading, finalized: !this.loading && this.finalized})}" @click="${() => this.onFinalizeConfiguration()}">
						<span>${this.loading ? msg('Preparing Downloads') : msg('Finalize Configuration')}</span>
						<span class="icon">${this.loading ? loading : next}</span>
					</button>
					<div class="ctaInfo">
						${msg('Configuration can not be changed after finalization.')}
					</div>
				</div>
			</div>
		`;
	}
}
